import { RemoteGetMapActivityDetails } from 'data/usecases/dashboard';
import { GetMapActivityDetails } from 'domain/usecases/dashboard';
import { makeApiUrlMapActivityDetails } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetMapActivityDetails = (): GetMapActivityDetails =>
  new RemoteGetMapActivityDetails(
    makeApiUrlMapActivityDetails(),
    makeAxiosHttpClient(),
  );
